import MonolithNotesAPI from "@/api/Notes";
import { styled } from "@monolith-forensics/monolith-ui";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { NotesListItem } from "./NoteListItem";
import { Note } from "@/Features/Notes";
import { TimelineEvent } from "../../TimelineEvents.types";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1 auto;
  height: 0px;

  overflow-y: auto;

  &[data-scroll-active="true"] {
    padding-right: 8px;
  }
`;

export const NotesList: React.FC<{
  defaultEventData: TimelineEvent;
  onNoteSelected?: (note: Note) => void;
  search?: string;
}> = ({ defaultEventData, onNoteSelected, search }) => {
  const [scrollActive, setScrollActive] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const { data } = useQuery({
    queryKey: [
      "case-notes",
      "list",
      { object_id: defaultEventData.uuid, include_content: false, search },
    ],
    queryFn: ({ queryKey }) => {
      const [, , query] = queryKey;
      return MonolithNotesAPI.getNotes(query);
    },
    placeholderData: (data) => data,
  });

  const notes = data?.data || [];

  useEffect(() => {
    if (containerRef.current) {
      setScrollActive(
        containerRef.current.scrollHeight > containerRef.current.clientHeight
      );
    }
  }, []);

  return (
    <StyledContainer
      ref={containerRef}
      className={"timeline-notes-list"}
      data-scroll-active={scrollActive}
    >
      {notes.map((note: Note) => (
        <NotesListItem
          key={note.uuid}
          data={note}
          onClick={() => onNoteSelected?.(note)}
        />
      ))}
    </StyledContainer>
  );
};
